// Анимация прокрутки
//window.AOS = require('aos/dist/aos');

// Модалки от фансибокса
window.fbx = require('@fancyapps/ui/dist/fancybox.esm');

//
require('vgloadmore/dist/jquery.vegas-loadMore');
